// commonfinanceriskdata.js

// Financial Reporting Risks (10 records)
const financialReportingRiskData = [
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-001",
    riskDescription: "Delayed month-end closing leading to inaccurate financial reports - Issue 1",
    riskCause: ["Inefficient reconciliation processes", "Manual data consolidation errors"],
    consequence: "Late or inaccurate financial reports impacting decision-making.",
    riskCategory: "Operational",
    processControlId: "CTRL-FR-001",
    processControlDescription: "Implement automated reconciliation and close processes.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Monthly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Delayed close", "Data errors"],
    auditTestingProcedures: ["Review close timelines", "Test automation controls"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-002",
    riskDescription: "Misstatement of financial results due to manual journal entry errors - Issue 2",
    riskCause: ["Human error in journal entries", "Lack of proper review"],
    consequence: "Inaccurate financial statements leading to misinformed decisions.",
    riskCategory: "Financial",
    processControlId: "CTRL-FR-002",
    processControlDescription: "Implement automated journal entry systems with supervisory reviews.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive & Detective",
    processControlCategory: "Financial",
    frequency: "Daily",
    processControlOwner: "Controller",
    expectedDeviations: ["Entry errors", "Unapproved adjustments"],
    auditTestingProcedures: ["Audit journal entries", "Reconcile adjustments"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-003",
    riskDescription: "Incomplete consolidation of subsidiary data causing reporting gaps - Issue 3",
    riskCause: ["Data integration issues", "Delayed information from subsidiaries"],
    consequence: "Gaps in consolidated reports affecting overall financial insight.",
    riskCategory: "Operational",
    processControlId: "CTRL-FR-003",
    processControlDescription: "Enhance data integration processes and set strict deadlines for subsidiary reporting.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Monthly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Missing data", "Delayed inputs"],
    auditTestingProcedures: ["Compare subsidiary vs. consolidated data", "Review integration logs"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-004",
    riskDescription: "Inaccurate intercompany eliminations leading to inflated revenues - Issue 4",
    riskCause: ["Complex transactions", "Lack of automated eliminations"],
    consequence: "Overstated revenues and misrepresentation of group performance.",
    riskCategory: "Financial",
    processControlId: "CTRL-FR-004",
    processControlDescription: "Automate intercompany eliminations and conduct regular reviews.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Overstated revenue", "Reconciliation mismatches"],
    auditTestingProcedures: ["Test elimination processes", "Review intercompany schedules"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-005",
    riskDescription: "Inefficient reconciliation of bank statements causing data discrepancies - Issue 5",
    riskCause: ["Manual reconciliation", "Inconsistent bank data"],
    consequence: "Discrepancies in cash balances affecting financial reports.",
    riskCategory: "Financial",
    processControlId: "CTRL-FR-005",
    processControlDescription: "Implement automated bank reconciliation tools.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Weekly",
    processControlOwner: "Treasury Manager",
    expectedDeviations: ["Unreconciled items", "Data mismatches"],
    auditTestingProcedures: ["Review bank reconciliation reports", "Test system accuracy"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-006",
    riskDescription: "Delayed recognition of accruals affecting period-end results - Issue 6",
    riskCause: ["Manual entry delays", "Lack of cutoff controls"],
    consequence: "Misstated expenses and liabilities in financial statements.",
    riskCategory: "Financial",
    processControlId: "CTRL-FR-006",
    processControlDescription: "Implement strict cutoff procedures with automated accruals.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Controller",
    expectedDeviations: ["Delayed accruals", "Entry errors"],
    auditTestingProcedures: ["Test cutoff procedures", "Review accrual entries"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-007",
    riskDescription: "Misclassification of expenses impacting profitability metrics - Issue 7",
    riskCause: ["Inadequate chart of accounts", "Manual classification errors"],
    consequence: "Skewed profit margins and misleading performance analysis.",
    riskCategory: "Financial",
    processControlId: "CTRL-FR-007",
    processControlDescription: "Review and standardize expense classifications and implement automated checks.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Controller",
    expectedDeviations: ["Misclassifications", "Inconsistent coding"],
    auditTestingProcedures: ["Audit expense allocations", "Test classification accuracy"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-008",
    riskDescription: "Data integration issues between ERP modules causing reporting errors - Issue 8",
    riskCause: ["Fragmented systems", "Lack of data synchronization"],
    consequence: "Erroneous financial reports due to inconsistent data.",
    riskCategory: "Operational",
    processControlId: "CTRL-FR-008",
    processControlDescription: "Integrate ERP modules using middleware solutions and perform regular data audits.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Weekly",
    processControlOwner: "IT Manager",
    expectedDeviations: ["Data discrepancies", "Outdated information"],
    auditTestingProcedures: ["Review integration logs", "Conduct data consistency tests"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-009",
    riskDescription: "Lack of timely adjustments for prior period errors - Issue 9",
    riskCause: ["Delayed error identification", "Inadequate review processes"],
    consequence: "Persisting inaccuracies in financial statements over periods.",
    riskCategory: "Financial",
    processControlId: "CTRL-FR-009",
    processControlDescription: "Implement a process for prompt identification and correction of prior period errors.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Controller",
    expectedDeviations: ["Delayed corrections", "Recurring errors"],
    auditTestingProcedures: ["Review error correction logs", "Test historical adjustments"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-FR-010",
    riskDescription: "Insufficient review of financial disclosures leading to non-compliance - Issue 10",
    riskCause: ["Lack of disclosure review process", "Inadequate legal oversight"],
    consequence: "Non-compliance with regulatory requirements and potential fines.",
    riskCategory: "Compliance",
    processControlId: "CTRL-FR-010",
    processControlDescription: "Establish a robust disclosure review process with periodic audits.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Compliance",
    frequency: "Quarterly",
    processControlOwner: "Finance Director",
    expectedDeviations: ["Missed disclosures", "Compliance lapses"],
    auditTestingProcedures: ["Review disclosure checklists", "Conduct regulatory audits"]
  }
];

// Accounts Payable Risks (10 records)
const accountsPayableRiskData = [
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-001",
    riskDescription: "Delayed invoice processing leading to late payments - Issue 1",
    riskCause: ["Inefficient workflow", "Manual processing delays"],
    consequence: "Late payment penalties and strained vendor relationships.",
    riskCategory: "Operational",
    processControlId: "CTRL-AP-001",
    processControlDescription: "Automate invoice processing and set up timely alerts.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "AP Manager",
    expectedDeviations: ["Processing delays", "Missed invoices"],
    auditTestingProcedures: ["Review processing times", "Audit invoice logs"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-002",
    riskDescription: "Duplicate payments due to system errors - Issue 2",
    riskCause: ["Data entry errors", "Lack of duplicate checks"],
    consequence: "Financial loss and increased reconciliation efforts.",
    riskCategory: "Financial",
    processControlId: "CTRL-AP-002",
    processControlDescription: "Implement duplicate detection algorithms in the payment system.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive & Detective",
    processControlCategory: "Financial",
    frequency: "Daily",
    processControlOwner: "AP Manager",
    expectedDeviations: ["Duplicate invoices", "Overpayments"],
    auditTestingProcedures: ["Review payment records", "Test duplicate detection controls"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-003",
    riskDescription: "Fraudulent invoices resulting in unauthorized payments - Issue 3",
    riskCause: ["Lack of vendor verification", "Weak internal controls"],
    consequence: "Financial loss and reputational damage.",
    riskCategory: "Compliance",
    processControlId: "CTRL-AP-003",
    processControlDescription: "Strengthen vendor verification and segregate duties in invoice approvals.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Compliance",
    frequency: "Per invoice",
    processControlOwner: "AP Manager",
    expectedDeviations: ["Unauthorized payments", "Vendor fraud"],
    auditTestingProcedures: ["Review vendor records", "Test segregation of duties"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-004",
    riskDescription: "Inaccurate vendor data causing payment errors - Issue 4",
    riskCause: ["Outdated vendor information", "Lack of regular updates"],
    consequence: "Payment errors and vendor disputes.",
    riskCategory: "Operational",
    processControlId: "CTRL-AP-004",
    processControlDescription: "Maintain an up-to-date vendor master file with periodic reviews.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Monthly",
    processControlOwner: "AP Manager",
    expectedDeviations: ["Data inaccuracies", "Payment mismatches"],
    auditTestingProcedures: ["Audit vendor master file", "Review data update logs"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-005",
    riskDescription: "Missed early payment discounts due to processing delays - Issue 5",
    riskCause: ["Delayed invoice approvals", "Inefficient workflows"],
    consequence: "Loss of discount benefits, increasing overall costs.",
    riskCategory: "Financial",
    processControlId: "CTRL-AP-005",
    processControlDescription: "Streamline approval workflows and set early payment alerts.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Daily",
    processControlOwner: "AP Manager",
    expectedDeviations: ["Missed discounts", "Processing delays"],
    auditTestingProcedures: ["Review discount capture rates", "Test workflow efficiency"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-006",
    riskDescription: "Disputes with vendors over payment terms - Issue 6",
    riskCause: ["Ambiguous contract terms", "Lack of standardized procedures"],
    consequence: "Vendor dissatisfaction and potential legal disputes.",
    riskCategory: "Operational",
    processControlId: "CTRL-AP-006",
    processControlDescription: "Standardize vendor contracts and payment terms.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Annually",
    processControlOwner: "AP Manager",
    expectedDeviations: ["Contract disputes", "Inconsistent terms"],
    auditTestingProcedures: ["Review contract terms", "Audit payment disputes"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-007",
    riskDescription: "Inadequate segregation of duties in invoice approvals - Issue 7",
    riskCause: ["Insufficient internal controls", "Consolidated responsibilities"],
    consequence: "Increased risk of fraud and error.",
    riskCategory: "Compliance",
    processControlId: "CTRL-AP-007",
    processControlDescription: "Enforce segregation of duties and regular control reviews.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Compliance",
    frequency: "Per invoice",
    processControlOwner: "AP Manager",
    expectedDeviations: ["Control breaches", "Fraudulent approvals"],
    auditTestingProcedures: ["Review approval logs", "Test duty segregation"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-008",
    riskDescription: "Failure to reconcile vendor statements leading to unresolved discrepancies - Issue 8",
    riskCause: ["Manual reconciliation gaps", "Lack of timely reviews"],
    consequence: "Unresolved discrepancies increasing risk of overpayments.",
    riskCategory: "Operational",
    processControlId: "CTRL-AP-008",
    processControlDescription: "Automate reconciliation of vendor statements with regular exception reports.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive & Detective",
    processControlCategory: "Operational",
    frequency: "Weekly",
    processControlOwner: "AP Manager",
    expectedDeviations: ["Unreconciled items", "Data discrepancies"],
    auditTestingProcedures: ["Review exception reports", "Test reconciliation controls"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-009",
    riskDescription: "Non-compliance with tax withholding requirements - Issue 9",
    riskCause: ["Lack of updated tax data", "Inadequate process controls"],
    consequence: "Regulatory penalties and interest charges.",
    riskCategory: "Compliance",
    processControlId: "CTRL-AP-009",
    processControlDescription: "Integrate tax withholding updates into the AP system and perform regular reviews.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Compliance",
    frequency: "Monthly",
    processControlOwner: "Tax Manager",
    expectedDeviations: ["Incorrect tax withholdings", "Non-compliance issues"],
    auditTestingProcedures: ["Review tax calculation logs", "Test withholding accuracy"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AP-010",
    riskDescription: "Inefficient handling of payment exceptions causing backlog - Issue 10",
    riskCause: ["Lack of clear exception procedures", "System limitations"],
    consequence: "Backlog in payment processing leading to delayed disbursements.",
    riskCategory: "Operational",
    processControlId: "CTRL-AP-010",
    processControlDescription: "Develop a clear process for managing payment exceptions and automate escalations.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "AP Manager",
    expectedDeviations: ["Backlog accumulation", "Delayed resolution"],
    auditTestingProcedures: ["Review exception logs", "Test escalation procedures"]
  }
];

// Accounts Receivable Risks (10 records)
const accountsReceivableRiskData = [
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-001",
    riskDescription: "Delayed collection of receivables affecting cash flow - Issue 1",
    riskCause: ["Inefficient dunning process", "Poor customer follow-up"],
    consequence: "Negative impact on liquidity and working capital.",
    riskCategory: "Operational",
    processControlId: "CTRL-AR-001",
    processControlDescription: "Automate dunning processes and set collection reminders.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "AR Manager",
    expectedDeviations: ["Delayed collections", "Missed follow-ups"],
    auditTestingProcedures: ["Review aging reports", "Test dunning effectiveness"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-002",
    riskDescription: "Inaccurate billing leading to disputed invoices - Issue 2",
    riskCause: ["Manual billing errors", "Lack of system checks"],
    consequence: "Customer disputes and delayed payments.",
    riskCategory: "Operational",
    processControlId: "CTRL-AR-002",
    processControlDescription: "Implement automated billing with validation rules.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "AR Manager",
    expectedDeviations: ["Billing inaccuracies", "Disputed amounts"],
    auditTestingProcedures: ["Audit billing processes", "Reconcile customer accounts"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-003",
    riskDescription: "Failure to update customer credit limits causing exposure - Issue 3",
    riskCause: ["Inadequate credit reviews", "Outdated customer data"],
    consequence: "Excessive credit risk and potential bad debts.",
    riskCategory: "Financial",
    processControlId: "CTRL-AR-003",
    processControlDescription: "Establish regular credit reviews and update limits accordingly.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Credit Manager",
    expectedDeviations: ["Credit limit misalignment", "Increased defaults"],
    auditTestingProcedures: ["Review credit files", "Test limit updates"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-004",
    riskDescription: "High levels of bad debt due to inadequate credit assessment - Issue 4",
    riskCause: ["Poor credit scoring", "Lack of robust assessment processes"],
    consequence: "Increased write-offs and impaired cash flow.",
    riskCategory: "Financial",
    processControlId: "CTRL-AR-004",
    processControlDescription: "Implement a rigorous credit assessment framework.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Quarterly",
    processControlOwner: "Credit Manager",
    expectedDeviations: ["Increased defaults", "Inaccurate scoring"],
    auditTestingProcedures: ["Review credit policies", "Analyze bad debt ratios"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-005",
    riskDescription: "Inefficient dunning process resulting in delayed collections - Issue 5",
    riskCause: ["Manual follow-ups", "Lack of automated reminders"],
    consequence: "Prolonged collection cycles and reduced cash inflows.",
    riskCategory: "Operational",
    processControlId: "CTRL-AR-005",
    processControlDescription: "Automate the dunning process and monitor overdue receivables.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "AR Manager",
    expectedDeviations: ["Delayed follow-ups", "Long outstanding balances"],
    auditTestingProcedures: ["Review dunning logs", "Analyze collection cycles"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-006",
    riskDescription: "Misapplication of customer payments leading to reconciliation errors - Issue 6",
    riskCause: ["Manual allocation mistakes", "Lack of automation"],
    consequence: "Errors in accounts receivable aging and cash application.",
    riskCategory: "Operational",
    processControlId: "CTRL-AR-006",
    processControlDescription: "Implement automated payment application and regular reconciliations.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive & Detective",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "AR Manager",
    expectedDeviations: ["Unapplied cash", "Reconciliation mismatches"],
    auditTestingProcedures: ["Review payment allocations", "Test reconciliation procedures"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-007",
    riskDescription: "Data integration issues between billing and AR systems causing errors - Issue 7",
    riskCause: ["Fragmented systems", "Lack of real-time updates"],
    consequence: "Inconsistent customer account data leading to disputes.",
    riskCategory: "Operational",
    processControlId: "CTRL-AR-007",
    processControlDescription: "Integrate billing and AR systems for real-time data updates.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Weekly",
    processControlOwner: "IT Manager",
    expectedDeviations: ["Data lags", "Record inconsistencies"],
    auditTestingProcedures: ["Review system integration", "Test data synchronization"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-008",
    riskDescription: "Unrecorded adjustments affecting receivables aging reports - Issue 8",
    riskCause: ["Delayed updates", "Manual errors"],
    consequence: "Inaccurate aging reports leading to misinformed collection strategies.",
    riskCategory: "Operational",
    processControlId: "CTRL-AR-008",
    processControlDescription: "Automate adjustment recording and regularly update aging reports.",
    processControlDesign: "automated",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "AR Manager",
    expectedDeviations: ["Data omissions", "Aging inaccuracies"],
    auditTestingProcedures: ["Audit adjustments", "Review aging report accuracy"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-009",
    riskDescription: "Inadequate follow-up on overdue invoices increasing credit risk - Issue 9",
    riskCause: ["Inefficient collection practices", "Lack of escalation procedures"],
    consequence: "Higher bad debt exposure and cash flow issues.",
    riskCategory: "Operational",
    processControlId: "CTRL-AR-009",
    processControlDescription: "Implement automated follow-up procedures and escalation protocols.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "AR Manager",
    expectedDeviations: ["Delayed collections", "Non-escalated accounts"],
    auditTestingProcedures: ["Review collection metrics", "Test escalation controls"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-AR-010",
    riskDescription: "Customer disputes over pricing impacting receivables - Issue 10",
    riskCause: ["Incorrect billing", "Miscommunication of terms"],
    consequence: "Delayed collections and revenue leakage.",
    riskCategory: "Operational",
    processControlId: "CTRL-AR-010",
    processControlDescription: "Implement price verification checks and clear billing communication.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Operational",
    frequency: "Monthly",
    processControlOwner: "AR Manager",
    expectedDeviations: ["Disputed invoices", "Delayed payments"],
    auditTestingProcedures: ["Review dispute logs", "Assess pricing controls"]
  }
];

// Budgeting & Forecasting Risks (10 records)
const budgetingForecastingRiskData = [
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-001",
    riskDescription: "Overly optimistic revenue forecasts leading to budget overruns - Issue 1",
    riskCause: ["Inaccurate historical data", "Optimistic assumptions"],
    consequence: "Budget overruns and resource misallocation.",
    riskCategory: "Financial",
    processControlId: "CTRL-BF-001",
    processControlDescription: "Implement realistic forecasting models with historical benchmarks.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Quarterly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Forecast variances", "Overoptimism"],
    auditTestingProcedures: ["Compare forecasts with actuals", "Review model assumptions"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-002",
    riskDescription: "Inaccurate expense projections causing significant variances - Issue 2",
    riskCause: ["Underestimated costs", "Outdated pricing information"],
    consequence: "Budget discrepancies impacting financial planning.",
    riskCategory: "Financial",
    processControlId: "CTRL-BF-002",
    processControlDescription: "Regularly update expense models and incorporate current pricing data.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Financial",
    frequency: "Quarterly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Expense variances", "Underestimated costs"],
    auditTestingProcedures: ["Review expense trends", "Compare forecast vs. actual expenses"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-003",
    riskDescription: "Lack of scenario planning resulting in inflexible budgets - Issue 3",
    riskCause: ["Static forecasting models", "Limited contingency planning"],
    consequence: "Inability to adapt budgets to changing conditions.",
    riskCategory: "Operational",
    processControlId: "CTRL-BF-003",
    processControlDescription: "Incorporate scenario planning into the budgeting process.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Annually",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Inflexible budgets", "Missed contingency measures"],
    auditTestingProcedures: ["Review scenario analyses", "Test flexibility of budgets"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-004",
    riskDescription: "Data inaccuracies in historical performance affecting forecasts - Issue 4",
    riskCause: ["Poor data quality", "Lack of data validation"],
    consequence: "Forecast errors leading to improper planning.",
    riskCategory: "Operational",
    processControlId: "CTRL-BF-004",
    processControlDescription: "Enhance data validation processes and ensure data integrity.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Historical data errors", "Forecast inaccuracies"],
    auditTestingProcedures: ["Audit data sources", "Test data integrity controls"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-005",
    riskDescription: "Insufficient stakeholder input leading to unrealistic budgets - Issue 5",
    riskCause: ["Lack of cross-departmental communication", "Limited consultation"],
    consequence: "Budgets that do not reflect actual business needs.",
    riskCategory: "Operational",
    processControlId: "CTRL-BF-005",
    processControlDescription: "Establish a multi-departmental budgeting committee.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Annually",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Unrealistic targets", "Budget misalignment"],
    auditTestingProcedures: ["Review committee minutes", "Assess budget rationale"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-006",
    riskDescription: "Delayed budgeting process causing missed opportunities - Issue 6",
    riskCause: ["Inefficient workflows", "Procrastination in decision-making"],
    consequence: "Late budgets impacting strategic initiatives.",
    riskCategory: "Operational",
    processControlId: "CTRL-BF-006",
    processControlDescription: "Streamline budgeting processes and set firm deadlines.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Annually",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Delayed submissions", "Missed opportunities"],
    auditTestingProcedures: ["Review process timelines", "Test adherence to deadlines"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-007",
    riskDescription: "Inadequate monitoring of budget vs. actuals leading to large variances - Issue 7",
    riskCause: ["Lack of real-time monitoring", "Insufficient variance analysis"],
    consequence: "Unexpected budget overruns or underspends.",
    riskCategory: "Financial",
    processControlId: "CTRL-BF-007",
    processControlDescription: "Implement real-time budget tracking and regular variance reviews.",
    processControlDesign: "automated",
    typeOfProcessControl: "Detective",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["High variances", "Delayed adjustments"],
    auditTestingProcedures: ["Review variance reports", "Test monitoring systems"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-008",
    riskDescription: "Failure to update forecasts with real-time data - Issue 8",
    riskCause: ["Static models", "Delayed data feeds"],
    consequence: "Outdated forecasts leading to poor decision-making.",
    riskCategory: "Operational",
    processControlId: "CTRL-BF-008",
    processControlDescription: "Integrate real-time data feeds into forecasting models.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Outdated forecasts", "Data delays"],
    auditTestingProcedures: ["Review data feeds", "Test real-time updates"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-009",
    riskDescription: "Poor integration of financial and operational data affecting planning - Issue 9",
    riskCause: ["Data silos", "Lack of integrated systems"],
    consequence: "Misaligned budgets that do not reflect operational realities.",
    riskCategory: "Operational",
    processControlId: "CTRL-BF-009",
    processControlDescription: "Integrate financial and operational systems for cohesive planning.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Quarterly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Data misalignment", "Planning errors"],
    auditTestingProcedures: ["Review integration processes", "Test data consistency"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-BF-010",
    riskDescription: "Lack of contingency budgeting for unforeseen events - Issue 10",
    riskCause: ["Inadequate risk analysis", "Overly rigid budget structures"],
    consequence: "Insufficient funds during crises leading to operational disruption.",
    riskCategory: "Financial",
    processControlId: "CTRL-BF-010",
    processControlDescription: "Incorporate contingency funds and conduct regular risk assessments.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Annually",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Insufficient reserves", "Rigid budgets"],
    auditTestingProcedures: ["Review contingency allocations", "Assess risk planning processes"]
  }
];

// Cash Management Risks (10 records)
const cashManagementRiskData = [
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-001",
    riskDescription: "Delayed cash reconciliations impacting liquidity visibility - Issue 1",
    riskCause: ["Manual reconciliation delays", "Outdated systems"],
    consequence: "Inaccurate cash position affecting liquidity decisions.",
    riskCategory: "Operational",
    processControlId: "CTRL-CM-001",
    processControlDescription: "Automate cash reconciliations and establish daily review protocols.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "Treasury Manager",
    expectedDeviations: ["Delayed reconciliations", "Data lags"],
    auditTestingProcedures: ["Review reconciliation reports", "Test system timeliness"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-002",
    riskDescription: "Excessive idle cash due to inefficient cash forecasting - Issue 2",
    riskCause: ["Poor forecasting", "Lack of cash optimization strategies"],
    consequence: "Underutilized cash leading to lower investment returns.",
    riskCategory: "Financial",
    processControlId: "CTRL-CM-002",
    processControlDescription: "Improve cash forecasting models and optimize surplus cash deployment.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Treasury Manager",
    expectedDeviations: ["Excess cash", "Forecast variances"],
    auditTestingProcedures: ["Review cash forecasts", "Analyze idle cash levels"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-003",
    riskDescription: "Inadequate cash flow monitoring leading to liquidity crises - Issue 3",
    riskCause: ["Delayed reporting", "Insufficient monitoring tools"],
    consequence: "Unanticipated cash shortages affecting operations.",
    riskCategory: "Operational",
    processControlId: "CTRL-CM-003",
    processControlDescription: "Implement real-time cash flow monitoring systems.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "Treasury Manager",
    expectedDeviations: ["Late detection of shortages", "Data inaccuracies"],
    auditTestingProcedures: ["Test monitoring dashboards", "Review cash flow reports"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-004",
    riskDescription: "Errors in bank statement reconciliations causing data discrepancies - Issue 4",
    riskCause: ["Manual processing errors", "Inconsistent bank data"],
    consequence: "Misstated cash balances affecting financial decisions.",
    riskCategory: "Operational",
    processControlId: "CTRL-CM-004",
    processControlDescription: "Automate bank statement reconciliations with validation checks.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Weekly",
    processControlOwner: "Treasury Manager",
    expectedDeviations: ["Reconciliation errors", "Data mismatches"],
    auditTestingProcedures: ["Review bank reconciliation logs", "Test validation rules"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-005",
    riskDescription: "Inefficient use of cash surplus affecting investment returns - Issue 5",
    riskCause: ["Lack of investment strategy", "Delayed cash allocation"],
    consequence: "Missed opportunities for higher returns on surplus cash.",
    riskCategory: "Financial",
    processControlId: "CTRL-CM-005",
    processControlDescription: "Develop a cash investment strategy and automate surplus allocation.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Monthly",
    processControlOwner: "Treasury Manager",
    expectedDeviations: ["Underutilized cash", "Delayed investments"],
    auditTestingProcedures: ["Review investment reports", "Test allocation process"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-006",
    riskDescription: "Failure to optimize working capital resulting in increased financing costs - Issue 6",
    riskCause: ["Inefficient cash management", "Poor vendor and customer payment terms"],
    consequence: "Higher short-term borrowing and increased interest expenses.",
    riskCategory: "Financial",
    processControlId: "CTRL-CM-006",
    processControlDescription: "Regularly assess working capital and negotiate better payment terms.",
    processControlDesign: "manual",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Quarterly",
    processControlOwner: "Treasury Manager",
    expectedDeviations: ["Inefficient cash conversion", "Increased borrowing"],
    auditTestingProcedures: ["Review working capital metrics", "Assess term negotiations"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-007",
    riskDescription: "Inaccurate forecasting of cash needs leading to overdraft situations - Issue 7",
    riskCause: ["Poor cash forecasting", "Unexpected expenses"],
    consequence: "Overdraft fees and strained banking relationships.",
    riskCategory: "Financial",
    processControlId: "CTRL-CM-007",
    processControlDescription: "Enhance cash forecasting with historical data and real-time monitoring.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Financial",
    frequency: "Daily",
    processControlOwner: "Treasury Manager",
    expectedDeviations: ["Overdraft occurrences", "Forecast variances"],
    auditTestingProcedures: ["Test forecasting models", "Review overdraft incidents"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-008",
    riskDescription: "Delayed processing of cash transfers causing settlement issues - Issue 8",
    riskCause: ["Manual intervention delays", "System inefficiencies"],
    consequence: "Settlement delays impacting vendor and customer relationships.",
    riskCategory: "Operational",
    processControlId: "CTRL-CM-008",
    processControlDescription: "Automate cash transfer processes with defined SLAs.",
    processControlDesign: "automated",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Daily",
    processControlOwner: "Treasury Manager",
    expectedDeviations: ["Transfer delays", "Settlement discrepancies"],
    auditTestingProcedures: ["Review transfer logs", "Test system processing times"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-009",
    riskDescription: "Poor integration between treasury and accounting systems causing data lags - Issue 9",
    riskCause: ["Incompatible systems", "Lack of data synchronization"],
    consequence: "Delayed cash data affecting decision-making.",
    riskCategory: "Operational",
    processControlId: "CTRL-CM-009",
    processControlDescription: "Integrate treasury and accounting systems using middleware solutions.",
    processControlDesign: "system dependent",
    typeOfProcessControl: "Preventive",
    processControlCategory: "Operational",
    frequency: "Weekly",
    processControlOwner: "IT Manager",
    expectedDeviations: ["Data lags", "Inconsistent records"],
    auditTestingProcedures: ["Review integration logs", "Test synchronization accuracy"]
  },
  {
    industry: "Common",
    department: "Finance",
    riskId: "FIN-CM-010",
    riskDescription: "Lack of controls over petty cash leading to misappropriation - Issue 10",
    riskCause: ["Weak internal controls", "Inadequate tracking"],
    consequence: "Financial loss and potential fraud.",
    riskCategory: "Compliance",
    processControlId: "CTRL-CM-010",
    processControlDescription: "Implement strict petty cash controls and regular reconciliations.",
    processControlDesign: "manual",
    typeOfProcessControl: "Detective",
    processControlCategory: "Compliance",
    frequency: "Monthly",
    processControlOwner: "Finance Manager",
    expectedDeviations: ["Unreconciled cash", "Misappropriation incidents"],
    auditTestingProcedures: ["Audit petty cash logs", "Conduct surprise cash counts"]
  }
];

const commonFinanceRiskData = [
  ...financialReportingRiskData,
  ...accountsPayableRiskData,
  ...accountsReceivableRiskData,
  ...budgetingForecastingRiskData,
  ...cashManagementRiskData
];

export default commonFinanceRiskData;
